import './styles/main.scss';

import { createApp } from 'vue';

import router from './router';
import store from './store';

import App from './App.vue';
import BaseButton from '@/components/BaseButton';
import ErrorMessage from '@/components/ErrorMessage';

const app = createApp(App);
app.use(router);
app.use(store);

app.component('BaseButton', BaseButton);
app.component('ErrorMessage', ErrorMessage);

app.mount('#app');
